import { render, staticRenderFns } from "./PTable.vue?vue&type=template&id=7e052dda&scoped=true"
import script from "./PTable.vue?vue&type=script&lang=js"
export * from "./PTable.vue?vue&type=script&lang=js"
import style0 from "./PTable.vue?vue&type=style&index=0&id=7e052dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e052dda",
  null
  
)

export default component.exports